module.exports = __webpack_public_path__ + "static/OtherSide-6bd9b96899767fd21f78517bff9a0fce.jpeg";